import { ClientPaymentStatus, IClientTicketFullPayment } from '@bustickus/models-client';
import * as bi from 'react-bootstrap-icons';
import { Button, Flex } from 'components';
import { useState } from 'react';
import { SpoilerCard } from 'shared/components';
import { DataRow } from '..';
import './style.scss';
import moment from 'moment-timezone';

interface IProps {
  payment: IClientTicketFullPayment;
}

function PaymentCard(props: IProps) {
  const [open, setOpen] = useState<boolean>(props.payment.status !== 'succeeded');

  const handlePayClick = () => {
    if (props.payment.paymentUrl == null) {
      return;
    }

    window.location.href = props.payment.paymentUrl;
  };

  return (
    <SpoilerCard
      title='Данные оплаты'
      open={open}
      onOpenClick={() => setOpen(!open)}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Flex direction='column'>
          <DataRow
            icon={<bi.Coin />}
            title='Статус: '
            value={getPayementStatus(props.payment.status)}
          />
          <DataRow
            icon={<bi.Calendar />}
            value={moment(props.payment.date).format('DD MMMM YYYY HH:mm:ss')}
          />
        </Flex>

        {props.payment.paymentUrl != null && (
          <Button
            color='red'
            onClick={handlePayClick}
          >
            <Flex
              justifyContent='center'
              gap={5}
              alignItems='center'
            >
              <bi.Cash />
              <span>Оплатить билет</span>
            </Flex>
          </Button>
        )}

        <span className='payment-id-Sbml'>{props.payment.id}</span>
      </Flex>
    </SpoilerCard>
  );
}

function getPayementStatus(status: ClientPaymentStatus): React.ReactNode {
  if (status === 'canceled') {
    return <i className='p-status-error-sMPp'>Оплата отменена</i>;
  }

  if (status === 'pending') {
    return <i className='p-status-warning-xNcN'>Ожидание оплаты...</i>;
  }

  if (status === 'waiting_for_capture') {
    return <i className='p-status-warning-xNcN'>Ожидание получения средств...</i>;
  }

  if (status === 'succeeded') {
    return <i className='p-status-success-2iPZ'>Оплата успешна</i>;
  }

  return <i className='p-status-error-sMPp'>Статус оплаты не определён!</i>;
}

export default PaymentCard;
